var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"appContainer"},[_c('MyMap',{attrs:{"locations":_vm.locations},on:{"clicked":function($event){return _vm.getNetwork($event)}}}),_c('Infocard',{attrs:{"networksArray":_vm.networks,"countriesObj":_vm.countries}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }